import React, { useEffect, useState } from "react";
import "./style.css";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function ErrorPage({ isPublic }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // let search_params = "";
    // if (searchParams.get("login_type")) {
    //   search_params = search_params + `?login_type=${searchParams.get("login_type")}${searchParams.get("is_login") ? "&is_login=true" : ""}`;
    // }
    // navigate(isPublic ? `/login${search_params}` : "/");
  }, []);

  return <></>;
}
